import { render } from "./TextField.vue?vue&type=template&id=521de7a0&bindings={\"text\":\"props\",\"type\":\"props\",\"className\":\"props\"}"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"
script.render = render

export default script